import { render, staticRenderFns } from "./RiskQuizAgeRevisions.vue?vue&type=template&id=21d98a07"
import script from "./RiskQuizAgeRevisions.vue?vue&type=script&lang=ts"
export * from "./RiskQuizAgeRevisions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports